// extracted by mini-css-extract-plugin
export var clickable = "list-icon-module--clickable--91dac";
export var iconItem = "list-icon-module--iconItem--b3c62";
export var iconWrapper = "list-icon-module--iconWrapper--be1da";
export var iconsContainer = "list-icon-module--iconsContainer--7d7f2";
export var materialIcon = "list-icon-module--materialIcon--b725c";
export var root = "list-icon-module--root--31d09";
export var textIcon = "list-icon-module--textIcon--86dbd";
export var title = "list-icon-module--title--dc5cb";